export { StraightShooterGameCoreModule } from './straight-shooter-game-core.module';
export { StraightShooterGameSelectorComponent } from './straight-shooter-game-selector/straight-shooter-game-selector.component';
export { StraightShooterGameCoreService } from './straight-shooter-game-core.service';
export { IStraightShooterGame } from './straight-shooter-game.interface';
